import { cn } from '@/services/Methods/normalMethods';
import { useRouter } from 'next/navigation'
import { useCallback, useRef } from 'react';

const ButtonComponent = ({ id = "", children, type = 'button', onClick, link, classes, disabled = false, conditionClass }) => {
  const router = useRouter();
  const isTouchHandledRef = useRef(false);

  const handleAction = useCallback(() => {
    if (disabled) {
      return;
    }

    if (link) {
      router.push(link);
    }

    if (onClick) {
      onClick();
    }
  }, [disabled, link, onClick, router]);

  const attachableHandlers = type !== "submit"
    ? {
      onClick: () => {
        if (isTouchHandledRef.current) {
          isTouchHandledRef.current = false;
          return;
        }
        handleAction();
      },
      onTouchStart: (event) => {
        isTouchHandledRef.current = true;
        event.preventDefault();
        handleAction();
      }
    }
    : {};

  return (
    <button
      type={type}
      id={id}
      disabled={disabled}
      className={cn(`site-btn`, classes, conditionClass || {})}
      {...attachableHandlers}
    >
      {children}
    </button>
  );
};

export default ButtonComponent;
